// removed by extract-text-webpack-plugin
module.exports = {"root":"FpsFocus_root_3iL"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/game/modes/FpsMode/FpsFocus.css
 ** module id = 572
 ** module chunks = 0
 **/